/** @format */

import { useState, useEffect } from 'react';
import './IsMobile.scss';

const IsMobile = () => {
  const [isFixedMobile, setIsFixedMobile] = useState(null);
  const handleResize = () => {
    let screenWidth = window.innerWidth;
    if (screenWidth <= 769) {
      setIsFixedMobile(true);
    } else {
      setIsFixedMobile(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isFixedMobile;
};

export default IsMobile;
